import * as React from 'react'
import { WithGoogleMapProps } from 'react-google-maps/lib/'
import { geocodeByAddress } from 'react-places-autocomplete'
import { geolocated } from 'react-geolocated'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { routerActions, RouterAction } from 'react-router-redux'

import { Map } from '../components/Map'

import { ROUTES } from '../constants/routes'

import { AppBarContainer } from './CustomAppBar'

import '../styles/App.scss'
import '../styles/PickupLocation.scss'

import {
    ClientInfo,
    AddressInfo,
    LatLng,
    JobPrototype,
    Job,
    PublishedJobParams,
    AttachmentParams,
    JobCategory
} from '../types'

import Footer from '../components/Footer'
import ErrorDialog from '../components/ErrorDialog'

import {
    Actions as SignInActions,
    ActionType as SignInActionType
} from '../actions/signIn'
import {
    Actions as JobActions,
    ActionType as JobActionType
} from '../actions/job'
import {
    Actions as UserAction,
    ActionType as UserActionType
} from '../actions/user'
import {
    Actions as ServiceActions,
    ActionType as ServiceActionType
} from '../actions/serviceInfo'
import { StoreState } from '../reducers'
import { ADDRESS_COMPONENTS } from '../constants/geocoder'
import JobUtils from '../utils/JobUtils'
import { ClientType, JobStatus } from '../types/enums'
import { Api } from '../services/api/api'

import { LoadingSpinner } from '../components/LoadingSpinner'
import intersection from 'lodash.intersection'
import {
    setPublishedJobParams,
    setJobId,
    setJobStatus,
    addComment,
    setFutureDateFrom,
    setFutureDateTo,
    setBagsNumber,
    setItemsOutside,
    setItemsInside,
    setAmount,
    setMsaId,
    setElevatorUse,
    setStairsNeeded,
    setAttachments,
    setAddress,
    selectJobCategory,
    setJobCategories,
    setSubCategories,
    setSelectedJobCategory,
    setProviderId,
    setJobRequestId
} from '../actions/setJobDetails'

import { JobCategories } from '../types/jobCategories'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'

import {
    ActionType as ErrorInfoActionType,
    Actions as ErrorActions
} from '../actions/errorInfo'
import { Error as ErrorInfo } from '../types/Errors/Error'
import Mapper from '../utils/Mapper'
import MessageDialog, { MessageDialogProps } from '../components/MessageDialog'
import { PreferenceType } from '../types/enums/PreferenceType'
import { JobRequestType, JobRequestStatus } from '../types/JobRequest'

let USACenterCoords: LatLng = {
    lat: 39.8333333,
    lng: -98.585522
}

interface PickupLocationProps {
    client: ClientInfo
    currentLocation?: LatLng
    useCurrentJob: boolean
    currentJob: JobPrototype
    jobStatus: string
    onErrorEvent: (errorInfo: ErrorInfo) => ErrorInfoActionType
    setCurrentJobUsed: () => ServiceActionType
    routePush: (location: string) => RouterAction
    setCurrentLocation: (location: LatLng) => UserActionType
    createJob: (job: JobPrototype) => JobActionType
    updateUser: (client: ClientInfo) => SignInActionType
    onSetJobId: (jobId: string) => void
    onPublishedJobParams: (publishedJobParams: PublishedJobParams) => void
    onSetJobStatus: (status: string) => void
    setProviderId: (providerId: string) => void
    onAddComment: (event: string) => string
    onSetFutureDateFrom: (futureDateFrom: number) => void
    onSetFutureDateTo: (futureDateTo: number) => void
    onNumberOfBags: (event: any) => any
    onSetItemsOutside: (areItemsOutside: boolean) => void
    onSetItemsInside: (areItemsInside: boolean) => void
    onSetAmount: (amount: number) => void
    onSetMsaId: (msaId: string) => void
    onSetElevatorUse: (isElevatorNeeded: boolean) => void
    onSetStairsNeeded: (areStairsNeeded: boolean) => void
    onSetAttachments: (files: AttachmentParams[] | null) => void
    setAddress: (address?: AddressInfo) => any
    onSelectJobCategory: (name: string, id: string) => void
    onSetJobCategories: (jobCategories: Array<any>) => void
    onSetSubCategories: (subCategories: Array<any>) => void
    onSelectedJobCategory: (selectedJobCategory: string) => void
}

interface PickupLocationState {
    address: string
    apartmentNumber: string
    isApartment: boolean
    addressInfo?: AddressInfo
    isMarkerShown: boolean
    zipCode?: string
    markerPosition?: LatLng
    zoomNumber: number
    errorTitle: string
    errorMessage: string
    isErrorDialogOpen: boolean
    isMyLocationButtonDisabled: boolean
    isDrawerOpen: boolean
    isComponentLoading: boolean
    isThereActiveJob: boolean
    checkingJobStatus: boolean
    messageDialog: MessageDialogProps
    businessPostJobMessage: string
    missingStreetNumberMessage: string
}

export class PickupLocationComponent extends React.Component<
    PickupLocationProps,
    PickupLocationState
> {
    private mapNode: React.Component<WithGoogleMapProps, any> | null

    constructor(props: any) {
        super(props)
        if (this.props.useCurrentJob && this.props.currentJob !== null) {
            this.state = {
                isApartment:
                    this.props.currentJob.address &&
                    this.props.currentJob.address.apartmentNumber
                        ? true
                        : false,
                addressInfo: this.props.currentJob.address,
                address: JobUtils.buildAddress(this.props.currentJob.address),
                markerPosition: JobUtils.getJobCoordinates(
                    this.props.currentJob.coordinates
                ),
                zoomNumber: 10,
                apartmentNumber:
                    this.props.currentJob &&
                    this.props.currentJob.address &&
                    this.props.currentJob.address.apartmentNumber
                        ? this.props.currentJob.address.apartmentNumber
                        : '',
                errorTitle: '',
                errorMessage: '',
                isErrorDialogOpen: false,
                isMarkerShown: true,
                isMyLocationButtonDisabled: false,
                isDrawerOpen: false,
                isComponentLoading: true,
                isThereActiveJob: false,
                checkingJobStatus: false,
                messageDialog: {
                    isDialogOpened: false
                },
                businessPostJobMessage: '',
                missingStreetNumberMessage: ''
            }
        } else {
            this.state = {
                isApartment: false,
                isMarkerShown: false,
                address: '',
                zoomNumber: 10,
                apartmentNumber: '',
                errorTitle: '',
                errorMessage: '',
                isErrorDialogOpen: false,
                isMyLocationButtonDisabled: false,
                isDrawerOpen: false,
                isComponentLoading: true,
                isThereActiveJob: false,
                checkingJobStatus: false,
                messageDialog: {
                    isDialogOpened: false
                },
                businessPostJobMessage: '',
                missingStreetNumberMessage: ''
            }
        }
    }

    async componentDidMount() {
        this.checkActiveJobStatus()
        // tslint:disable-next-line: no-floating-promises
        Api.getActiveJobs().then((result: Array<any>) => {
            if (result && result.length !== 0) {
                if (
                    result[0].expectedStatus !== JobStatus.DECLINED_AUTO &&
                    result[0].expectedStatus !==
                        JobStatus.DECLINED_BY_CUSTOMER &&
                    result[0].expectedStatus !== JobStatus.DECLINED_BY_HAULER &&
                    result[0].status !== JobStatus.BIDS_AWAITING_ACCEPTANCE
                ) {
                    // tslint:disable-next-line: no-floating-promises
                    this.setJobDetails(result[0], true)
                }
            }
        })

        const messages = await Promise.all([
            Api.getPreference(PreferenceType.BusinessPostJobMessage),
            Api.getPreference(PreferenceType.MissingStreetNumberMessage)
        ])
        this.setState({
            businessPostJobMessage: messages[0].value,
            missingStreetNumberMessage: messages[1].value
        })

        if (this.props.client && !this.props.client.isTermsAccepted) {
            this.props.routePush(ROUTES.TERMS)
        }
        if (this.props.currentJob && this.props.currentJob.coordinates) {
            let coords = this.props.currentJob.coordinates
            let lat = coords.substring(0, coords.indexOf(','))
            let lng = coords.substring(coords.indexOf(',') + 1)
            let position = { lat: Number(lat), lng: Number(lng) }
            this.processCoords(position)
        } else if (this.props.currentLocation) {
            this.processCoords(this.props.currentLocation)
        } else {
            this.getCurrentPosition()
        }
    }

    getActiveJob = () => {
        this.setState({
            checkingJobStatus: true
        })
        Api.getActiveJobs()
            .then((result: Array<any>) => {
                if (result && result.length !== 0) {
                    if (
                        result[0].expectedStatus !== JobStatus.DECLINED_AUTO &&
                        result[0].expectedStatus !==
                            JobStatus.DECLINED_BY_CUSTOMER &&
                        result[0].expectedStatus !==
                            JobStatus.DECLINED_BY_HAULER
                    ) {
                        this.checkActiveJobStatus()
                        // tslint:disable-next-line: no-floating-promises
                        this.setJobDetails(result[0])
                    }
                }
            })
            .then(() =>
                this.setState({
                    checkingJobStatus: false
                })
            )
            .catch(error => {
                // console.log(error)
                this.props.onErrorEvent(Mapper.mapError(error))
                this.setState({
                    checkingJobStatus: false
                })
            })
    }

    setJobDetails = async (job: Job, route?: boolean) => {
        let status = job.status
        let hours = Math.floor(job.timeKeeping / 3600000)
        let minutes = Math.floor((job.timeKeeping - hours * 3600000) / 60000)
        let seconds = Math.floor(
            (job.timeKeeping - minutes * 60000 - hours * 3600000) / 1000
        )

        let publishedJobParams = {
            confirmed: true,
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            createDate: job.createDate,
            timeKeeping: job.timeKeeping,
            timeStopBidding: job.timeStopBidding,
            secondTimeKeeping: 0,
            biddingActiveDate: 0
        }

        console.log(job.haulerId)
        this.props.setProviderId(job.haulerId as string)
        this.props.onSetJobId(job.id)
        this.props.onPublishedJobParams(publishedJobParams)
        this.props.onSetJobStatus(job.status)

        this.props.onAddComment(job.note ? job.note : '')
        this.props.onSetFutureDateFrom(job.futureDateFrom)
        this.props.onSetFutureDateTo(job.futureDateTo)
        this.props.onNumberOfBags(job.jobItems ? job.jobItems : null)
        this.props.onSetItemsOutside(
            job.areItemsOutside ? job.areItemsOutside : false
        )
        this.props.onSetItemsInside(
            job.areItemsInside ? job.areItemsInside : false
        )
        this.props.onSetAmount(job.amount ? job.amount : 0)
        this.props.onSetMsaId(job.msaId ? job.msaId : '')
        this.props.onSetElevatorUse(
            job.isElevatorNeeded ? job.isElevatorNeeded : false
        )
        this.props.onSetStairsNeeded(
            job.areStairsNeeded ? job.areStairsNeeded : false
        )
        this.props.onSetAttachments(job.attachments ? job.attachments : null)
        this.props.setAddress(job.address)

        Api.getCategoriesByZipCode(job.address.zipCode)
            .then((jobCategories: JobCategories[]) => {
                let selectedJobCategory = jobCategories.find(
                    (jobCategory: JobCategory) =>
                        jobCategory.id === job.jobCategoryId
                )
                let index = jobCategories.findIndex(
                    (jobCategory: JobCategory) =>
                        jobCategory.id === job.jobCategoryId
                )

                let jobCategoryName =
                    selectedJobCategory && selectedJobCategory.name
                        ? selectedJobCategory.name
                        : ''
                let jobCategoryId =
                    selectedJobCategory && selectedJobCategory.id
                        ? selectedJobCategory.id
                        : ''
                this.props.onSelectJobCategory(jobCategoryName, jobCategoryId)
                this.props.onSelectedJobCategory(`${index}`)
                this.props.onSetJobCategories(jobCategories)
                this.props.onSetSubCategories(
                    jobCategories[index].subcategories
                )
            })
            .then(() => {
                if (this.state.isDrawerOpen || route) {
                    if (
                        status === JobStatus.ACCEPTED ||
                        status === JobStatus.CONFIRM_ARRIVAL ||
                        status === JobStatus.HAULER_ARRIVING
                    ) {
                        this.props.routePush(ROUTES.BID_ACCEPTED)
                    } else if (
                        status === JobStatus.CREATED ||
                        status === JobStatus.BIDDING_ACTIVE ||
                        status === JobStatus.BIDS_AWAITING_ACCEPTANCE ||
                        status ===
                            JobStatus.WAITING_FOR_PAYMENT_AUTHORIZATION ||
                        status === JobStatus.UNDER_REVIEW
                    ) {
                        this.props.routePush(ROUTES.VIEW_BIDS)
                    } else if (status === JobStatus.COMPLETED) {
                        this.props.routePush(ROUTES.REVIEW_HAULER)
                    }
                }
            })
            .catch(error => {
                this.props.onErrorEvent(Mapper.mapError(error))
            })
    }

    getCurrentPosition = () => {
        if (!this.props.currentLocation) {
            navigator.geolocation.getCurrentPosition(
                (position: any) => {
                    let coords = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }
                    this.setState({
                        isMyLocationButtonDisabled: false
                    })
                    this.props.setCurrentLocation(coords)
                    this.processCoords(coords)
                },
                (error: any) => {
                    console.log(error)
                    let coords = USACenterCoords
                    this.props.setCurrentLocation(coords)
                    this.processCoords(coords)
                    this.setState({
                        isErrorDialogOpen: true,
                        errorTitle: StringResources.getString(
                            Strings.Common.Error
                        ),
                        errorMessage: StringResources.getString(
                            Strings.PickupLocation.Errors.Messages
                                .geolocationDenied
                        ),
                        isMyLocationButtonDisabled: true
                    })
                }
            )
        }
    }

    setAddress = position => {
        console.log(
            `set address: ${JSON.stringify(position.address_components)}`
        )
        let streetNumber = position.address_components.find(
            component =>
                component.types.indexOf(ADDRESS_COMPONENTS.STREET_NUMBER) >= 0
        )

        let city = position.address_components.find(
            component =>
                component.types.indexOf(ADDRESS_COMPONENTS.LOCALITY.primary) >=
                0
        )
        if (!city) {
            city = position.address_components.find(
                component =>
                    intersection(
                        component.types,
                        ADDRESS_COMPONENTS.LOCALITY.additional
                    ).length >= 0
            )
        }

        let country = position.address_components.find(
            component =>
                component.types.indexOf(ADDRESS_COMPONENTS.COUNTRY) >= 0
        )
        let region = position.address_components.find(
            component => component.types.indexOf(ADDRESS_COMPONENTS.REGION) >= 0
        )

        let streetName = position.address_components.find(
            component =>
                component.types.indexOf(ADDRESS_COMPONENTS.STREET.primary) >= 0
        )
        if (!streetName) {
            streetName = position.address_components.find(
                component =>
                    intersection(
                        component.types,
                        ADDRESS_COMPONENTS.STREET.additional
                    ).length > 0
            )
        }

        let zipCode = position.address_components.find(
            component =>
                component.types.indexOf(ADDRESS_COMPONENTS.POSTAL_CODE) >= 0
        )

        console.log(
            `parts: ${!!streetNumber} | ${!!streetName} | ${!!city} | ${!!region} | ${!!country} | ${!!zipCode}`
        )

        if (city && country && region && streetName && zipCode) {
            let streetFullName = streetNumber
                ? `${streetNumber.long_name} ${streetName.long_name}`
                : `${streetName.long_name}`

            let address: AddressInfo = {
                city: city.long_name,
                country: country.short_name,
                region: region.short_name,
                streetName: streetFullName,
                zipCode: zipCode.long_name,
                streetNumber: streetNumber ? streetNumber.long_name : undefined
            }
            this.setState({
                addressInfo: address
            })
        } else {
            this.setState({
                addressInfo: undefined
            })
        }

        this.setState({
            isComponentLoading: false
        })
    }

    handleErrorDialogClose = () => {
        this.setState({
            isErrorDialogOpen: false
        })
    }

    setJobLocation = async () => {
        if (this.state.addressInfo && this.state.markerPosition) {
            let addressInfo = { ...this.state.addressInfo }
            console.log(addressInfo)
            if (!addressInfo.streetNumber) {
                this.setState({
                    messageDialog: {
                        isDialogOpened: true,
                        message: this.state.missingStreetNumberMessage,
                        title: 'Set Job Location',
                        actions: [
                            {
                                caption: 'Ok',
                                onClick: () => {
                                    this.setState({
                                        messageDialog: { isDialogOpened: false }
                                    })
                                }
                            }
                        ]
                    }
                })
                return
            }

            const jobRequestId = (await this.createJobRequest()) as JobRequestType
            setJobRequestId(jobRequestId)
            this.routeToJobDetails(addressInfo, jobRequestId)
        }
    }
    routeToJobDetails = (addressInfo, jobRequestId) => {
        if (this.state.isApartment && this.state.apartmentNumber) {
            addressInfo.apartmentNumber = this.state.apartmentNumber
        }
        let coordinates = `${this.state.markerPosition!.lat},${
            this.state.markerPosition!.lng
        }`
        this.props.createJob({
            jobRequestId,
            zipCode: addressInfo.zipCode,
            address: addressInfo,
            coordinates: coordinates
        })
        this.props.routePush(ROUTES.JOB_DETAILS)
    }

    checkValidation = () => {
        console.log('Tries to validate')
    }

    createJobRequest = async () => {
        const { addressInfo } = this.state
        let coordinates = `${this.state.markerPosition!.lat},${
            this.state.markerPosition!.lng
        }`
        const jobRequest: JobRequestType = {
            clientId: this.props.client.username,
            address: addressInfo,
            zipCode: addressInfo ? addressInfo.zipCode : '',
            coordinates,
            status: JobRequestStatus.AT_JOB_DETAILS
        }

        return Api.createJobRequest(jobRequest)
    }

    processCoords = (coords: LatLng) => {
        console.log(`process coords: ${JSON.stringify(coords)}`)
        let geocoder = new google.maps.Geocoder()
        geocoder.geocode({ location: coords }, results => {
            if (results && results.length > 0) {
                this.processGeocoderResult(results[0], coords)
            }
        })
    }

    processGeocoderResult = (
        geocoderResult: google.maps.GeocoderResult,
        coords: LatLng | null
    ) => {
        console.log(`process result`)
        if (!coords) {
            coords = {
                lat: geocoderResult.geometry.location.lat(),
                lng: geocoderResult.geometry.location.lng()
            }
        }
        let zipCodeContainer = geocoderResult.address_components.find(
            component =>
                component.types.indexOf(ADDRESS_COMPONENTS.POSTAL_CODE) >= 0
        )
        console.log(`zip: ${JSON.stringify(zipCodeContainer)}`)
        if (!zipCodeContainer) {
            const geocoder = new google.maps.Geocoder()
            geocoder.geocode({ location: coords }, results => {
                if (results && results.length > 0) {
                    console.log(
                        `geocode zip: ${JSON.stringify(results, null, 4)}`
                    )
                    zipCodeContainer = results[0].address_components.find(
                        component =>
                            component.types.indexOf(
                                ADDRESS_COMPONENTS.POSTAL_CODE
                            ) >= 0
                    )
                    if(!zipCodeContainer) {
                        zipCodeContainer = results[1].address_components.find(
                            component =>
                                component.types.indexOf(
                                    ADDRESS_COMPONENTS.POSTAL_CODE
                                ) >= 0
                        )
                    }
                    if (zipCodeContainer) {
                        geocoderResult.address_components.push(zipCodeContainer)
                        this.processZipAndAddress(
                            zipCodeContainer.long_name || '',
                            geocoderResult,
                            coords!
                        )
                    }
                }
            })
        } else {
            this.processZipAndAddress(
                zipCodeContainer.long_name || '',
                geocoderResult,
                coords
            )
        }
    }

    processZipAndAddress = (
        zipCode: string,
        geocoderResult: google.maps.GeocoderResult,
        coords: LatLng
    ) => {
        this.setState(
            {
                zipCode: zipCode,
                address: geocoderResult.formatted_address,
                markerPosition: coords,
                isMarkerShown: true
            },
            () => {
                if (
                    this.mapNode &&
                    this.mapNode.state &&
                    this.mapNode.state.map
                ) {
                    this.mapNode.state.map.panTo(coords)
                }
                this.setAddress(geocoderResult)
            }
        )
    }

    onMapClick = (event: any) => {
        let selectedCoords: LatLng = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
        }
        this.processCoords(selectedCoords)
    }

    onAddressChanged = (address: string, complete: boolean) => {
        this.setState(
            {
                address: address
            },
            () => {
                if (complete) {
                    geocodeByAddress(address)
                        .then((results: google.maps.GeocoderResult[]) => {
                            this.processGeocoderResult(results[0], null)
                        })
                        .catch((error: string) => {
                            console.error('Error', error)
                            this.props.onErrorEvent(Mapper.mapError(error))
                        })
                } else {
                    this.removeMarker()
                }
            }
        )
    }
    onApartmentNumberChanged = (apartmentNumber: string) => {
        this.setState({
            apartmentNumber: apartmentNumber
        })
    }
    onApartmentEnabled = (isEnabled: boolean) => {
        this.setState({
            isApartment: isEnabled
        })
    }

    removeMarker = (eraseAddress: boolean = false) => {
        this.setState(prevState => {
            return {
                isMarkerShown: false,
                address: eraseAddress ? '' : prevState.address
            }
        })
    }

    checkActiveJobStatus() {
        let status = this.props.jobStatus
        if (status && status !== '' && !this.state.isThereActiveJob) {
            this.setState({
                isThereActiveJob: true
            })
            return true
        } else {
            return false
        }
    }

    openDrawer = () => {
        this.setState({
            isDrawerOpen: true
        })
    }

    render() {
        let setCurrentLocation = () => {
            if (this.state.isMyLocationButtonDisabled) {
                this.setState({
                    isErrorDialogOpen: true,
                    errorTitle: StringResources.getString(Strings.Common.Error),
                    errorMessage: StringResources.getString(
                        Strings.PickupLocation.Errors.Messages.geolocationDenied
                    )
                })
            } else {
                this.processCoords(
                    this.props.currentLocation
                        ? this.props.currentLocation
                        : USACenterCoords
                )
            }
        }
        return (
            <BaseContainer
                pageName={EventType.PICKUP_LOCATION}
                classname="job-location"
            >
                <LoadingSpinner
                    show={
                        this.state.isComponentLoading ||
                        this.state.checkingJobStatus
                    }
                    text={
                        this.state.checkingJobStatus
                            ? undefined
                            : StringResources.getString(
                                  Strings.PickupLocation.Loader.Text.locating
                              )
                    }
                />
                <AppBarContainer
                    isIconButtonsShown={true}
                    isMenuShown={true}
                    getActiveJob={this.getActiveJob}
                    openDrawer={this.openDrawer}
                />
                <Map
                    address={this.state.address}
                    apartmentNumber={this.state.apartmentNumber}
                    isApartmentNumberActive={this.state.isApartment}
                    markerCoords={this.state.markerPosition}
                    isMarkerShown={this.state.isMarkerShown}
                    zoomNumber={this.state.zoomNumber}
                    currentLocation={this.props.currentLocation}
                    onAddressChange={this.onAddressChanged}
                    onApartmentNumberChanged={this.onApartmentNumberChanged}
                    onApartmentEnabled={this.onApartmentEnabled}
                    setCurrentLocation={setCurrentLocation}
                    onClick={this.onMapClick}
                    containerElement={
                        <div className="map" style={{ height: '100%' }} />
                    }
                    mapElement={<div style={{ height: '100%' }} />}
                    ref={el => {
                        this.mapNode = el
                    }}
                    isMyLocationButtonDisabled={
                        this.state.isMyLocationButtonDisabled
                    }
                />
                <ErrorDialog
                    errorTitle={this.state.errorTitle}
                    errorMessage={this.state.errorMessage}
                    isErrorDialogOpen={this.state.isErrorDialogOpen}
                    handleErrorDialogClose={this.handleErrorDialogClose}
                />
                <Footer
                    setJobLocation={this.setJobLocation}
                    disabled={
                        !this.state.addressInfo ||
                        !this.state.markerPosition ||
                        this.checkActiveJobStatus() ||
                        this.state.isThereActiveJob
                    }
                />
                <MessageDialog {...this.state.messageDialog} />
            </BaseContainer>
        )
    }
}

const mapStateToProps = (state: StoreState) => {
    return {
        client: state.auth.user,
        currentLocation: state.user.coords,
        useCurrentJob: state.serviceInfo.useCurrentJob,
        currentJob: state.currentJob,
        jobStatus: state.jobDetails.status
    }
}

const mapDispatchToProps = (
    dispatch: Dispatch<
        RouterAction | JobActionType | UserActionType | ErrorInfoActionType
    >
) => {
    return {
        updateUser: (client: ClientInfo) =>
            dispatch(SignInActions.authorize(client)),
        routePush: (location: string) => dispatch(routerActions.push(location)),
        setCurrentLocation: (location: LatLng) =>
            dispatch(UserAction.setCurrentLocation(location)),
        createJob: (job: JobPrototype) => dispatch(JobActions.createJob(job)),
        setCurrentJobUsed: () => dispatch(ServiceActions.useCurrentJob(false)),
        setProviderId: (providerId: string) =>
            dispatch(setProviderId(providerId)),
        onPublishedJobParams: (publishedJobParams: PublishedJobParams) =>
            dispatch(setPublishedJobParams(publishedJobParams)),
        onSetJobId: (jobId: string) => dispatch(setJobId(jobId)),
        onSetJobStatus: (status: string) => dispatch(setJobStatus(status)),
        onAddComment: (note: string) => dispatch(addComment(note)),
        onSetFutureDateFrom: (futureDateFrom: number) =>
            dispatch(setFutureDateFrom(futureDateFrom)),
        onSetFutureDateTo: (futureDateTo: number) =>
            dispatch(setFutureDateTo(futureDateTo)),
        onNumberOfBags: (jobItem: [{ subCategoryId: string; count: number }]) =>
            dispatch(setBagsNumber(jobItem)),
        onSetItemsOutside: (areItemsOutside: boolean) =>
            dispatch(setItemsOutside(areItemsOutside)),
        onSetItemsInside: (areItemsInside: boolean) =>
            dispatch(setItemsInside(areItemsInside)),
        onSetAmount: (amount: number) => dispatch(setAmount(amount)),
        onSetMsaId: (msaId: string) => dispatch(setMsaId(msaId)),
        onSetElevatorUse: (isElevatorNeeded: boolean) =>
            dispatch(setElevatorUse(isElevatorNeeded)),
        onSetStairsNeeded: (areStairsNeeded: boolean) =>
            dispatch(setStairsNeeded(areStairsNeeded)),
        onSetAttachments: (files: Array<any>) =>
            dispatch(setAttachments(files)),
        setAddress: (address?: AddressInfo) => dispatch(setAddress(address)),
        onSetJobCategories: (jobCategories: Array<any>) =>
            dispatch(setJobCategories(jobCategories)),
        onSetSubCategories: (subCategories: Array<any>) =>
            dispatch(setSubCategories(subCategories)),
        onSelectJobCategory: (name: string, id: string) =>
            dispatch(selectJobCategory(name, id)),
        onErrorEvent: (errorInfo: ErrorInfo) =>
            dispatch(ErrorActions.newError(errorInfo)),
        onSelectedJobCategory: (selectedJobCategory: string) =>
            dispatch(setSelectedJobCategory(selectedJobCategory)),
        setJobRequestId: (jobRequestId?: string) =>
            dispatch(setJobRequestId(jobRequestId ? jobRequestId : ''))
    }
}

const PickupLocation = connect(
    mapStateToProps,
    mapDispatchToProps
)(PickupLocationComponent)

export default PickupLocation
// geolocated({
//   positionOptions: {
//     enableHighAccuracy: true,
//     timeout: Infinity
//   },
//   watchPosition: true
// })(PickupLocation)



// WEBPACK FOOTER //
// ./src/containers/PickupLocation.tsx